import { defineMessages } from 'react-intl';

export default defineMessages({
  newFolderName: {
    id: 'app.components.FolderForm.newFolderName',
    defaultMessage: 'Name of new folder',
  },
  purpose: {
    id: 'app.components.FolderForm.purpose',
    defaultMessage: 'Purpose of folder',
  },
  purposePublicInformation: {
    id: 'app.components.FolderForm.purposePublicInformation',
    defaultMessage: 'Information for all publishers',
  },
  purposeTeamLeaderInformation: {
    id: 'app.components.FolderForm.purposeTeamLeaderInformation',
    defaultMessage: 'Information for team leaders only',
  },
  purposeVipInformation: {
    id: 'app.components.FolderForm.purposeVipInformation',
    defaultMessage: 'Information for VIPs only',
  },
  purposeUploadTeamLeader: {
    id: 'app.components.FolderForm.purposeUploadTeamLeader',
    defaultMessage: 'Team leaders provide information to coordination team',
  },
  purposeCoordinationTeamExchange: {
    id: 'app.components.FolderForm.purposeCoordinationTeamExchange',
    defaultMessage: 'Coordination team internal',
  },
  expiration: {
    id: 'app.components.FolderForm.expiration',
    defaultMessage: 'Content will be automatically deleted',
  },
  expirationIsFixed: {
    id: 'app.components.FolderForm.expirationIsFixed',
    defaultMessage: 'Please note: This setting cannot be changed later.',
  },
  expiresNever: {
    id: 'app.components.FolderForm.expiresNever',
    defaultMessage: 'never',
  },
  expiresAfter7Days: {
    id: 'app.components.FolderForm.expiresAfter7Days',
    defaultMessage: 'after 7 days',
  },
  expiresAfter14Days: {
    id: 'app.components.FolderForm.expiresAfter14Days',
    defaultMessage: 'after 14 days',
  },
  expiresAfter30Days: {
    id: 'app.components.FolderForm.expiresAfter30Days',
    defaultMessage: 'after 30 days',
  },
});
